import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        if (!data.is_admin) {
          navigate("/admin/login?error=not_admin", { replace: true });
          return;
        }
        navigate("/admin", { replace: true, state: { user: data } });
      } catch {
        navigate("/admin/login?error=auth_failed", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F7FA]">
      <div className="text-[#0F2746] font-serif-ap text-2xl">Doğrulanıyor...</div>
    </div>
  );
}
